import { render, staticRenderFns } from "./Astrik.vue?vue&type=template&id=0683e482&"
import script from "./Astrik.vue?vue&type=script&lang=js&"
export * from "./Astrik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports